import { links } from 'bzx-common/src/config/appConfig'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import NftCollection from './NftCollection'
import nftsBanner from './nfts-banner.jpeg'

export default function Nfts() {
  return (
    <>
      <div className="nfts-grid  margin-bottom-1">
        <div className="panel--simple pos-rel overflow-hidden">
          <img className="nfts__banner" src={nftsBanner} />
        </div>
        <div className="flex-col">
          <div className="panel--simple md-padded-2 height-100p margin-bottom-1">
            <h3 className="txt-slogan">{"Collect OOKI NFT's"}</h3>
            <ul className="list-spaced-2">
              <li>Mascots</li>
              <li>Community members</li>
              <li>Ookiverse</li>
              <li>3-Dee</li>
            </ul>
          </div>
          <div className="panel--simple md-padded-2 margin-bottom-1 txt-explanation">
            {
              "Ooki NFT's are released as limited edition collections, follow Ooki on socials to stay up to date."
            }
          </div>
          <ExternalLink href={links.nfts} className="btn btn--blue btn--small-corners flex-center">
            {"Get your NFT's"}
          </ExternalLink>
        </div>
      </div>
      <NftCollection />
    </>
  )
}
